import { all } from 'redux-saga/effects';

export function* authRootSaga() {
  yield all([]);
}
